import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { API_CTX } from '@/config';
import { queryClient } from '@/lib/react-query';
import { restoreURL } from '@/lib/axios';

import { AI_QUERY_KEY } from '../types';

/**
 * Disable an AI module
 */
const disableAIModule = async (id: number) => {
  if (!id) return console.warn(`## NO id to update AI module!`);
  const data = {
    status: 'INACTIVE',
  };
  await restoreURL().patch(`${API_CTX}/ai-modules/${id}`, data);
};

export const useDisableAIModule = ({
  onSuccess,
}: {
  onSuccess?: () => void;
}) => {
  return useMutation<void, Error, { id: number }>(
    ({ id }) => disableAIModule(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(AI_QUERY_KEY);
        toast.success(`AI module disabled successfully`);

        if (onSuccess) {
          onSuccess();
        }
      },
      onError: (error: Error) => {
        toast.error(`An error occurs: ${error.message}`);
      },
    }
  );
};
